const fillableChars = ['N', 'O'];
let getInput = (el) => {
    let input = el;
    if (!(el instanceof HTMLInputElement)) {
        input = el.querySelector('input');
    }
    return input;
};

let applyMask=(val, mask)=>{
    let optCount = (mask.match(/O/g) || []).length;
    for(let i=Math.min(mask.length, val.length); i>=0; i--) {
        if (val[i] === mask[i] && !isFillableChar(mask[i])) {
            val = val.substring(0, i)+val.substring(i+1);
        }else if (val[i] === mask[i+optCount] && !isFillableChar(mask[i+optCount])) {
            val = val.substring(0, i)+val.substring(i+1);
        }
    }


    while(mask.includes('O')&&(mask.match(/[ON]/g) || []).length>val.length){
        mask = strReverse(strReverse(mask).replace('O', ''));
    }
    let masked=mask;

    for(let i=0; i<val.length; i++){
        masked = fillChar(masked, val[i]);
    }

    let index = firstFillableIndex(masked);
    if(index!==-1)
        masked=masked.substring(0, index);
    return masked;
};

let firstFillableIndex= (text)=>{
    return text.split('').findIndex(c=>fillableChars.indexOf(c)!==-1);
};

let isFillableChar = (char)=>{
    return fillableChars.includes(char);
};

let fillChar=(masked, char)=>{
    let index = firstFillableIndex(masked);
    if(index!==-1 && canFillChar(masked[index], char)){
        masked=masked.split('');
        masked[index] = char;
        masked=masked.join('');
    }
    return masked;
};

let canFillChar=(maskChar, val)=>{
    if(val===' '){
        return false;
    }else if(maskChar === 'N'){
        return !isNaN(val);
    }else if(maskChar==='O'){
        //o opcional deve ser um OR de todos os outros
        return !isNaN(val);
    }
    return false;
};

let listener = (ev)=>{
    ev.target.value = applyMask(ev.target.value, ev.target.dataset.mask)
};

let directive = {
    bind: function bind(el, binding) {
        let input = getInput(el);
        input.dataset.mask = binding.value;
        input.setAttribute('maxlength', input.dataset.mask.length);
        input.addEventListener('keyup', listener);
    },
    update: function update(el, binding) {
        let input = getInput(el);
        input.dataset.mask = binding.value;
        input.setAttribute('maxlength', input.dataset.mask.length);
        input.addEventListener('keyup', listener);
    },
    unbind: function unbind(el) {
        let input = getInput(el);
        input.removeAttribute('maxlength');
        input.addEventListener('keyup', listener);
    }
};

module.exports= {
    install:(Vue)=>{
        Vue.directive('masker', directive)
    },
    directive:directive
};

let strReverse = (str)=>str.split("").reverse().join("");